import * as React from "react";
import { useEffect, useState } from "react";
var StarList = function (_a) {
    var afterStarNumberChange = _a.afterStarNumberChange, isError = _a.isError, isClickable = _a.isClickable, note = _a.note;
    var _b = useState(note), selectedStars = _b[0], setSelectedStars = _b[1];
    useEffect(function () {
        setSelectedStars(note);
    }, [note]);
    var handleStarNumberChange = function (index) {
        setSelectedStars(index);
        if (typeof (afterStarNumberChange) === 'function') {
            afterStarNumberChange(index);
        }
    };
    var getStarType = function (star) {
        if (star <= selectedStars) {
            return 'full';
        }
        if (star - 0.5 < selectedStars) {
            return 'half';
        }
        return 'empty';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "stars " + (isError ? 'rating-empty-error' : '') }, [1, 2, 3, 4, 5].map(function (star, index) { return (React.createElement("span", { key: index, className: "star " + getStarType(star), onClick: isClickable ? function () { return handleStarNumberChange(star); } : undefined }, star <= selectedStars ? '★' : '☆')); }))));
};
export { StarList };
